"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.CheckIcon = (0, react_1.forwardRef)(function CheckIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M19.716 4.38643C19.8816 4.18296 20.1205 4.05269 20.3812 4.02371C20.6419 3.99472 20.9035 4.06934 21.1098 4.23147C21.316 4.39361 21.4502 4.63028 21.4836 4.89047C21.5169 5.15066 21.4467 5.41353 21.288 5.62243L10.665 19.1364C10.5275 19.3113 10.3528 19.4535 10.1535 19.5525C9.95425 19.6515 9.73546 19.705 9.51298 19.709C9.29051 19.713 9.06993 19.6675 8.86723 19.5757C8.66453 19.484 8.48478 19.3483 8.34101 19.1784L3.23702 13.1464C3.14864 13.0467 3.08108 12.9304 3.0383 12.8042C2.99552 12.678 2.97839 12.5446 2.98791 12.4117C2.99742 12.2788 3.0334 12.1491 3.09373 12.0303C3.15405 11.9115 3.2375 11.806 3.33919 11.7199C3.44087 11.6338 3.55873 11.5689 3.68584 11.529C3.81296 11.4891 3.94677 11.475 4.07941 11.4875C4.21205 11.5001 4.34085 11.539 4.45824 11.602C4.57564 11.665 4.67926 11.7508 4.76302 11.8544L9.47101 17.4184L19.716 4.38643Z", fill: "currentColor" })));
});
